import React from 'react'

import { Box, Typography } from '@material-ui/core'

import CategoryCard from '../CategoryCard'
import useStyles from './styles'

const CategoriesSection = ({ categories, allCourses, portalToken }) => {
  const classes = useStyles()

  const topCategories = categories
    .map((category) => ({
      category,
      courseCount: allCourses.filter((course) =>
        course.categories?.some((c) => c.id === category.id),
      ).length,
    }))
    .sort((a, b) => b.courseCount - a.courseCount)
    .slice(0, 5)

  return (
    <Box className={classes.root}>
      <Typography className={classes.header}>Explore por categoria</Typography>
      <Box className={classes.grid}>
        {topCategories.map(({ category }) => (
          <CategoryCard
            key={category.id}
            category={category}
            portalToken={portalToken}
          />
        ))}
      </Box>
    </Box>
  )
}

export default CategoriesSection
